export const everyHourChartData = {
  type: 'line',
  data: {
    labels: [],
    datasets: [
      { // another line graph
        label: 'Noticias extraidas a cada hora nas ultimas 24 horas',
        data: [],
        backgroundColor: [
          'rgba(134,192,255)', // Green
        ],
        borderColor: [
          '#007bff',
        ],
        borderWidth: 3
      }
    ]
  },
  options: {
    responsive: true,
    lineTension: 1,
    annotation: {
      annotations: [
        {
          drawTime: "afterDatasetsDraw",
          type: "line",
          mode: "vertical",
          scaleID: "x-axis-0",
          value: (function() {
            var DateTime = new Date();
            DateTime.setHours(DateTime.getHours() - 1);
            return DateTime.getHours() + DateTime.getMinutes() / 60;
          })(),
          borderWidth: 1,
          borderColor: "#007bff",
          label: {
            content: "Último",
            enabled: false,
            position: "top"
          }
        }
      ]
    },
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
          padding: 25,
        }
      }]
    }
  }
}

export default everyHourChartData;


// WEBPACK FOOTER //
// ./src/components/chart-data.js